import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-archives-idw-matrix-list',
    templateUrl: './archives-idw-matrix-list.component.html',
    styleUrls: ['./archives-idw-matrix-list.component.scss']
})
export class ArchivesIdwMatrixListComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
